import { Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { PumpingVisitBillingTypes } from "../../models/pumping-visit-billing-types.model";
import { PumpingVisitBillingTypesApi } from "../pumping-visit-billing-types.api";
import { lastValueFrom, map, Observable } from "rxjs";
import { FindOptionsDto } from "../../../../common/dto/find-options.dto";

@Injectable()
export class PumpingVisitBillingTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<PumpingVisitBillingTypes> {
    public resource = "pumpingVisitBillingTypes";

    private pageSize = 10;

    constructor(private pumpingVisitBillingTypesApi: PumpingVisitBillingTypesApi) {
        super();
    }

    public override async getById(id: number): Promise<PumpingVisitBillingTypes> {
        return lastValueFrom(this.pumpingVisitBillingTypesApi.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PumpingVisitBillingTypes>> {
        const dto: FindOptionsDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        return this.pumpingVisitBillingTypesApi.search(dto).pipe(
            map(result => ({
                items: result,
                nextPage: result.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: PumpingVisitBillingTypes): string {
        return item.value || "-";
    }
}
